module.exports = __webpack_public_path__ + "img/background_banner.44bbefff.png";